export class EventSetCoverImageModel {
    public eventId: number;
    public imageId: number;
}
